import _ from 'lodash'
import api from '../api'
import {
  uploadImageRequest,
  uploadImageSuccess,
  uploadImageError,
  deleteImageRequest,
  deleteImageSuccess,
  deleteImageError
} from './image'
import { setCurrentUser } from './login'
import { deleteImage } from '../utils/image'
import {
  validateRetailer,
  validateNewAccount,
  validatePassword
} from '../utils/validators'
import { searchRetailers } from '../utils/search'

export const FETCH_RETAILERS_REQUEST = 'FETCH_RETAILERS_REQUEST'
function fetchRetailersRequest() {
  return { type: FETCH_RETAILERS_REQUEST }
}

export const FETCH_RETAILERS_SUCCESS = 'FETCH_RETAILERS_SUCCESS'
function fetchRetailersSuccess(retailers, callback) {
  return { type: FETCH_RETAILERS_SUCCESS, retailers, callback }
}

export const FETCH_RETAILERS_ERROR = 'FETCH_RETAILERS_ERROR'
function fetchRetailersError(error) {
  return { type: FETCH_RETAILERS_ERROR, error }
}

export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST'
function fetchUsersRequest() {
  return { type: FETCH_USERS_REQUEST }
}

export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS'
function fetchUsersSuccess(users, callback) {
  return { type: FETCH_USERS_SUCCESS, users, callback }
}

export const FETCH_USERS_ERROR = 'FETCH_USERS_ERROR'
function fetchUsersError(error) {
  return { type: FETCH_USERS_ERROR, error }
}

export function fetchAllRetailers(dispatch, getState, query, callback, stripeOnboarded = false) {
  const pageNumber = query.start / query.length + 1
  let retailers = getState().retailer.get('retailers')
  const currentQuery = retailers && retailers.getMeta('query')
  // The Retailers and Featured sellers lists share this cached collection, so a
  // page cached for the unfiltered list must not be replayed into the
  // Stripe-onboarded list (or the other way round) — refetch when they differ.
  const currentScope = retailers ? Boolean(retailers.getMeta('stripeOnboarded')) : false
  if (
    !retailers ||
    retailers.getPageNumber() !== pageNumber ||
    (currentQuery && currentQuery !== query.search.value) ||
    currentScope !== stripeOnboarded
  ) {
    retailers = api.getRetailers(pageNumber, '', stripeOnboarded)
  }
  return Promise.resolve(retailers).then(
    retailers => {
      retailers._raw.meta = retailers._raw.meta || {}
      retailers._raw.meta.stripeOnboarded = stripeOnboarded
      dispatch(fetchRetailersSuccess(retailers, callback))
      return retailers
    },
    error => {
      dispatch(fetchRetailersError(error))
      throw error
    }
  )
}

export function fetchAllUsers(dispatch, getState, query, callback) {
  const pageNumber = query.start / query.length + 1
  let users = getState().retailer.get('users')
  const currentQuery = users && users.getMeta('query')
  if (
    !users ||
    users.getPageNumber() !== pageNumber ||
    (currentQuery && currentQuery !== query.search.value)
  ) {
    users = api.getUsers(pageNumber)
  }
  return Promise.resolve(users).then(
    users => {
      dispatch(fetchUsersSuccess(users, callback))
      return users
    },
    error => {
      dispatch(fetchUsersError(error))
      throw error
    }
  )
}

export function searchForRetailers(dispatch, query, callback, stripeOnboarded = false) {
  // return searchRetailers(query.search.value, query.start / query.length, 'hasStoreRepImg=1').then(
  //   retailers => {
  //     dispatch(fetchRetailersSuccess(retailers, callback))
  //     return retailers
  //   },
  //   error => {
  //     dispatch(fetchRetailersError(error))
  //     throw error
  //   }
  // )
  return api.getRetailers(query.start / query.length, query.search.value, stripeOnboarded).then(
    retailers => {
      // Tag the result with the search query so fetchAllRetailers can detect
      // when the search is cleared and must not reuse these cached results.
      retailers._raw.meta = retailers._raw.meta || {}
      retailers._raw.meta.query = query.search.value
      retailers._raw.meta.stripeOnboarded = stripeOnboarded
      dispatch(fetchRetailersSuccess(retailers, callback))
      return retailers
    },
    error => {
      dispatch(fetchRetailersError(error))
      throw error
    }
  )
}

export function searchForUsers(dispatch, query, callback) {
  // return searchRetailers(query.search.value, query.start / query.length, 'hasStoreRepImg=0').then(
  //   retailers => {
  //     dispatch(fetchRetailersSuccess(retailers, callback))
  //     return retailers
  //   },
  //   error => {
  //     dispatch(fetchRetailersError(error))
  //     throw error
  //   }
  // )
  return api.getUsers(query.start / query.length, query.search.value).then(
    retailers => {
      retailers._raw.meta = retailers._raw.meta || {}
      retailers._raw.meta.query = query.search.value
      dispatch(fetchUsersSuccess(retailers, callback))
      return retailers
    },
    error => {
      dispatch(fetchUsersError(error))
      throw error
    }
  )
}

export function fetchRetailers(query, callback, stripeOnboarded = false) {
  return (dispatch, getState) => {
    dispatch(fetchRetailersRequest())
    if (query.search.value) {
      return searchForRetailers(dispatch, query, callback, stripeOnboarded)
    }
    return fetchAllRetailers(dispatch, getState, query, callback, stripeOnboarded)
  }
}

export function fetchUsers(query, callback) {
  return (dispatch, getState) => {
    dispatch(fetchUsersRequest())
    if (query.search.value) {
      return searchForUsers(dispatch, query, callback)
    }
    return fetchAllUsers(dispatch, getState, query, callback)
  }
}

export const GET_RETAILER_REQUEST = 'GET_RETAILER_REQUEST'
function getRetailerRequest() {
  return { type: GET_RETAILER_REQUEST }
}

export const GET_RETAILER_SUCCESS = 'GET_RETAILER_SUCCESS'
export function getRetailerSuccess(retailer) {
  return { type: GET_RETAILER_SUCCESS, retailer }
}

export const GET_RETAILER_ERROR = 'GET_RETAILER_ERROR'
function getRetailerError(error) {
  return { type: GET_RETAILER_ERROR, error }
}

export function getRetailer(retailerId) {
  return (dispatch) => {
    dispatch(getRetailerRequest())
    return api.getRetailer(retailerId).then(
      retailer => {
        dispatch(getRetailerSuccess(retailer))
      },
      error => {
        dispatch(getRetailerError(error))
      }
    )
  }
}

export const CREATE_RETAILER = 'CREATE_RETAILER'
export function createRetailer() {
  return { type: CREATE_RETAILER }
}

export const SAVE_RETAILER_REQUEST = 'SAVE_RETAILER_REQUEST'
function saveRetailerRequest() {
  return { type: SAVE_RETAILER_REQUEST }
}

export const SAVE_RETAILER_SUCCESS = 'SAVE_RETAILER_SUCCESS'
function saveRetailerSuccess(retailer) {
  return { type: SAVE_RETAILER_SUCCESS, retailer }
}

export const SAVE_RETAILER_ERROR = 'SAVE_RETAILER_ERROR'
function saveRetailerError(error) {
  return { type: SAVE_RETAILER_ERROR, error }
}

export function saveRetailer(
  data,
  { galleryImages, repImage, logoImage, mastheadImage }
) {
  return (dispatch, getState) => {
    dispatch(saveRetailerRequest())
    const retailerValidation = validateRetailer(data.attributes)
    const currentUser = getState().login.get('currentUser')
    let passwordValidation
    if (data.id) {
      passwordValidation = validatePassword(data.attributes, false)
    } else {
      passwordValidation = validateNewAccount(data.attributes)
    }
    if (!passwordValidation.valid || !retailerValidation.valid) {
      const error = _.extend(
        passwordValidation.error,
        retailerValidation.error,
        {
          type: 'validation'
        }
      )
      dispatch(saveRetailerError(error))
      return Promise.reject(error)
    }
    return (data.id
      ? api.updateRetailer(data.id, data)
      : api.addRetailer(data)).then(
        retailer => {
          return (galleryImages || [])
            .reduce((step, { file }) => {
              return step
                .then(() => {
                  dispatch(uploadImageRequest())
                  return api.uploadImage(retailer.type, retailer.id, file)
                })
                .then(
                  image => {
                    dispatch(uploadImageSuccess(image))
                  },
                  error => {
                    dispatch(uploadImageError(error))
                  }
                )
            }, Promise.resolve())
            .then(() => {
              if (repImage) {
                return api.uploadRetailerRepImage(retailer.id, repImage.file)
              }
            })
            .then(() => {
              if (logoImage) {
                return api.uploadRetailerLogoImage(retailer.id, logoImage.file)
              }
            })
            .then(() => {
              if (mastheadImage) {
                return api.uploadRetailerMastheadImage(retailer.id, mastheadImage.file)
              }
            })
            .then(() => {
              return api.getRetailer(retailer.id)
            })
            .then(retailer => {
              dispatch(saveRetailerSuccess(retailer))
              if (currentUser.type === 'retailer') {
                dispatch(setCurrentUser(retailer))
              }
            })
        },
        error => {
          dispatch(saveRetailerError(error))
          throw error
        }
      )
  }
}

export const DELETE_RETAILER_REQUEST = 'DELETE_RETAILER_REQUEST'
function deleteRetailerRequest() {
  return { type: DELETE_RETAILER_REQUEST }
}

export const DELETE_RETAILER_SUCCESS = 'DELETE_RETAILER_SUCCESS'
function deleteRetailerSuccess() {
  return { type: DELETE_RETAILER_SUCCESS }
}

export const DELETE_RETAILER_ERROR = 'DELETE_RETAILER_ERROR'
function deleteRetailerError(error) {
  return { type: DELETE_RETAILER_ERROR, error }
}

export function deleteRetailer(retailer) {
  return dispatch => {
    dispatch(deleteRetailerRequest())
    return api.deleteRetailer(retailer.id).then(
      () => {
        dispatch(deleteRetailerSuccess())
      },
      error => {
        dispatch(deleteRetailerError(error))
        throw error
      }
    )
  }
}

export const DELETE_RETAILER_IMAGE_SUCCESS = 'DELETE_RETAILER_IMAGE_SUCCESS'
function deleteRetailerImageSuccess(image) {
  return { type: DELETE_RETAILER_IMAGE_SUCCESS, image }
}

export function deleteRetailerImage(retailer, image) {
  return (dispatch, getState) => {
    dispatch(deleteImageRequest())
    return api.deleteRetailerImage(retailer.id, image).then(
      () => {
        const selectedRetailer = getState().retailer.get('selectedRetailer')
        const imageEntity = selectedRetailer && selectedRetailer.findIncluded(image)
        const imageUrl = imageEntity && imageEntity.attributes.url
        if (imageUrl) {
          deleteImage(imageUrl)
        }
        dispatch(deleteImageSuccess())
        dispatch(deleteRetailerImageSuccess(image))
      },
      error => {
        dispatch(deleteImageError(error))
      }
    )
  }
}

export function deleteRetailerImages(retailer, images) {
  return dispatch => {
    return api.deleteRetailerImage(retailer.id, images).then(
      () => {},
      error => {
        dispatch(deleteImageError(error))
        throw error
      }
    )
  }
}

export const DELETE_RETAILER_REP_IMAGE_SUCCESS = 'DELETE_RETAILER_REP_IMAGE_SUCCESS'
function deleteRetailerRepImageSuccess() {
  return { type: DELETE_RETAILER_REP_IMAGE_SUCCESS }
}

export function deleteRetailerRepImage(retailer) {
  return dispatch => {
    dispatch(deleteImageRequest())
    return api.deleteRetailerRepImage(retailer.id).then(
      () => {
        dispatch(deleteImageSuccess())
        dispatch(deleteRetailerRepImageSuccess())
      },
      error => {
        dispatch(deleteImageError(error))
        throw error
      }
    )
  }
}

export const DELETE_RETAILER_MASTHEAD_IMAGE_SUCCESS = 'DELETE_RETAILER_MASTHEAD_IMAGE_SUCCESS'
function deleteRetailerMastheadImageSuccess() {
  return { type: DELETE_RETAILER_MASTHEAD_IMAGE_SUCCESS }
}

export function deleteRetailerMastheadImage(retailer) {
  return dispatch => {
    dispatch(deleteImageRequest())
    return api.deleteRetailerMastheadImage(retailer.id).then(
      () => {
        dispatch(deleteImageSuccess())
        dispatch(deleteRetailerMastheadImageSuccess())
      },
      error => {
        dispatch(deleteImageError(error))
        throw error
      }
    )
  }
}

export const CHECK_RETAILER_CUSTOM_URL_REQUEST =
  'CHECK_RETAILER_CUSTOM_URL_REQUEST'
function checkRetailerCustomUrlRequest() {
  return { type: CHECK_RETAILER_CUSTOM_URL_REQUEST }
}

export const CHECK_RETAILER_CUSTOM_URL_SUCCESS =
  'CHECK_RETAILER_CUSTOM_URL_SUCCESS'
function checkRetailerCustomUrlSuccess(result) {
  return { type: CHECK_RETAILER_CUSTOM_URL_SUCCESS, result }
}

export const CHECK_RETAILER_CUSTOM_URL_ERROR = 'CHECK_RETAILER_CUSTOM_URL_ERROR'
function checkRetailerCustomUrlError(error) {
  return { type: CHECK_RETAILER_CUSTOM_URL_REQUEST, error }
}

export function checkRetailerCustomUrl(customUrl) {
  return dispatch => {
    dispatch(checkRetailerCustomUrlRequest())
    return api.getRetailerByCustomUrl(customUrl).then(
      () => {
        dispatch(checkRetailerCustomUrlSuccess(false))
      },
      error => {
        if (error.status === 404) {
          dispatch(checkRetailerCustomUrlSuccess(true))
        } else {
          dispatch(checkRetailerCustomUrlError(error))
        }
      }
    )
  }
}

export const RESET_CHECK_RETAILER_CUSTOM_URL = 'RESET_CHECK_RETAILER_CUSTOM_URL'
export function resetCheckRetailerCustomUrl() {
  return { type: RESET_CHECK_RETAILER_CUSTOM_URL }
}

export const CONNECT_STRIPE_REQUEST = 'CONNECT_STRIPE_REQUEST'
export const connectStripeRequest = () => ({ type: CONNECT_STRIPE_REQUEST })

export const CONNECT_STRIPE_ERROR = 'CONNECT_STRIPE_ERROR'
export const connectStripeError = error => ({
  type: CONNECT_STRIPE_ERROR,
  error
})

export const savePayPalClientId = paypalClientId => {
  return (dispatch, getState) => {
    dispatch(saveRetailerRequest())
    const retailerId = getState().login.get('currentUser').id
    return api
      .updateRetailer(retailerId, {
        id: retailerId,
        type: 'retailer',
        attributes: { paypalClientId }
      })
      .then(
        retailer => {
          dispatch(saveRetailerSuccess(retailer))
          dispatch(setCurrentUser(retailer))
          return retailer
        },
        error => {
          dispatch(saveRetailerError(error))
          throw error
        }
      )
  }
}

//add feature

export const ADD_FEATURE_SELLER_REQUEST = 'ADD_FEATURE_SELLER_REQUEST'
function addFeatureSellerRequest() {
  return { type: ADD_FEATURE_SELLER_REQUEST }
}

export const ADD_FEATURE_SELLER_SUCCESS = 'ADD_FEATURE_SELLER_SUCCESS'
function addFeatureSellerSuccess(addFeature) {
  return { type: ADD_FEATURE_SELLER_SUCCESS, addFeature }
}

export const ADD_FEATURE_SELLER_ERROR = 'ADD_FEATURE_SELLER_ERROR'
function addFeatureSellerError(error) {
  return { type: ADD_FEATURE_SELLER_ERROR, error }
}


export function addFeaturedSeller(data) {
  return (dispatch) => {
    dispatch(addFeatureSellerRequest())
    return api.addFeature(data).then(
      (res) => {
        dispatch(addFeatureSellerSuccess(res))
        return res
      },
      (error) => {
        dispatch(addFeatureSellerError(error))
        return error
      }
    )
  }
}


// Delete_Comment
export const Delete_Comment_REQUEST = 'Delete_Comment_REQUEST'
function deleteCommentRequest() {
  return { type: Delete_Comment_REQUEST }
}

export const Delete_Comment_SUCCESS = 'Delete_Comment_SUCCESS'
function deleteCommentSuccess(deleteComment) {
  return { type: Delete_Comment_SUCCESS, deleteComment }
}

export const Delete_Comment_ERROR = 'Delete_Comment_ERROR'
function deleteCommentError(error) {
  return { type: Delete_Comment_ERROR, error }
}


export function deleteCommentList(data) {
  return (dispatch) => {
    dispatch(deleteCommentRequest())
    return api.deleteComment(data).then(
      (res) => {
        dispatch(deleteCommentSuccess(res))
        return res
      },
      (error) => {
        dispatch(deleteCommentError(error))
        return Promise.reject(error)
      })
  }
}
//remove feature
export const REMOVE_FEATURE_SELLER_REQUEST = 'REMOVE_FEATURE_SELLER_REQUEST'
function removeFeatureSellerRequest() {
  return { type: REMOVE_FEATURE_SELLER_REQUEST }
}

export const REMOVE_FEATURE_SELLER_SUCCESS = 'REMOVE_FEATURE_SELLER_SUCCESS'
function removeFeatureSellerSuccess(removeFeature) {
  return { type: REMOVE_FEATURE_SELLER_SUCCESS, removeFeature }
}

export const REMOVE_FEATURE_SELLER_ERROR = 'REMOVE_FEATURE_SELLER_ERROR'
function removeFeatureSellerError(error) {
  return { type: REMOVE_FEATURE_SELLER_ERROR, error }
}


export function removeFeaturedSeller(data) {
  return (dispatch) => {
    dispatch(removeFeatureSellerRequest())
    return api.removeFeature(data).then(
      (res) => {
        dispatch(removeFeatureSellerSuccess(res))
        return res
      },
      (error) => {
        dispatch(removeFeatureSellerError(error))
        return error
      }
    )
  }

}

// Delete_Review
export const Delete_Review_REQUEST = 'Delete_Review_REQUEST'
function deleteReviewRequest() {
  return { type: Delete_Review_REQUEST }
}

export const Delete_Review_SUCCESS = 'Delete_Review_SUCCESS'
function deleteReviewSuccess(deleteReview) {
  return { type: Delete_Review_SUCCESS, deleteReview }
}

export const Delete_Review_ERROR = 'Delete_Review_ERROR'
function deleteReviewError(error) {
  return { type: Delete_Review_ERROR, error }
}


export function deleteReviewList(data) {
  return (dispatch) => {
    dispatch(deleteReviewRequest())
    return api.deleteReview(data).then(
      (res) => {
        dispatch(deleteReviewSuccess(res))
        return res
      },
      (error) => {
        dispatch(deleteReviewError(error))
        return Promise.reject(error)
      }
    )
  }
}


export const ALL_RETAILER_REQUEST = 'ALL_RETAILER_REQUEST'
function allRetailerRequest() {
  return { type: ALL_RETAILER_REQUEST }
}

//get all retailer
export const ALL_RETAILER_SUCCESS = 'ALL_RETAILER_SUCCESS'
function allRetailerSuccess(retailers) {
  return { type: REMOVE_FEATURE_SELLER_SUCCESS, retailers }
}

export const ALL_RETAILER_ERROR = 'ALL_RETAILER_ERROR'
function allRetailerError(error) {
  return { type: ALL_RETAILER_ERROR, error }
}


export function allRetailerFunc(page) {
  return (dispatch) => {
    dispatch(allRetailerRequest())
    return api.allRetailers(page).then(
      (res) => {
        dispatch(allRetailerSuccess(res))
        return res
      },
      (error) => {
        dispatch(allRetailerError(error))
        return error
      }
    )
  }

}

// Delete_Product
export const Delete_Product_REQUEST = 'Delete_Product_REQUEST'
function deleteProductRequest() {
  return { type: Delete_Product_REQUEST }
}

export const Delete_Product_SUCCESS = 'Delete_Product_SUCCESS'
function deleteProductSuccess(deleteProduct) {
  return { type: Delete_Product_SUCCESS, deleteProduct }
}

export const Delete_Product_ERROR = 'Delete_Product_ERROR'
function deleteProductError(error) {
  return { type: Delete_Product_ERROR, error }
}


export function deleteProductList(data) {
  return (dispatch) => {
    dispatch(deleteProductRequest())
    return api.deleteProduct(data).then(
      (res) => {
        dispatch(deleteProductSuccess(res))
        return res
      },
      (error) => {
        dispatch(deleteProductError(error))
        return error
      }
    )
  }

}

//get review
export const GET_REVIEW_REQUEST = 'GET_REVIEW_REQUEST'
function getReviewsRequest() {
  return { type: GET_REVIEW_REQUEST }
}

export const GET_REVIEW_SUCCESS = 'GET_REVIEW_SUCCESS'
export function getReviewsSuccess(Reviews) {
  return { type: GET_REVIEW_SUCCESS, Reviews }
}

export const GET_REVIEW_ERROR = 'GET_REVIEW_ERROR'
function getReviewsError(error) {
  return { type: GET_REVIEW_ERROR, error }
}

export function getReviews(productId) {

  return (dispatch) => {
    dispatch(getReviewsRequest())
    return api.viewReviews(productId).then(
      (res) => {
        dispatch(getReviewsSuccess(res))
        return res
      },
      (error) => {
        dispatch(getReviewsError(error))
        return error
      }
    )
  }

}






//Get Comment
export const GET_COMMENT_REQUEST = 'GET_COMMENT_REQUEST'
function getCommentRequest() {
  return { type: GET_COMMENT_REQUEST }
}

export const GET_COMMENT_SUCCESS = 'GET_COMMENT_SUCCESS'
export function getCommentSuccess(Comments) {
  return { type: GET_COMMENT_SUCCESS, Comments }
}

export const GET_COMMENT_ERROR = 'GET_COMMENT_ERROR'
function getCommentError(error) {
  return { type: GET_COMMENT_ERROR, error }
}

export function getComment(productId) {

  return (dispatch) => {
    dispatch(getCommentRequest())
    return api.viewComments(productId).then(
      (res) => {
        dispatch(getCommentSuccess(res))
        return res
      },
      (error) => {
        dispatch(getCommentError(error))
        return error
      }
    )
  }

}


//add Best Collection

export const ADD_BEST_COLLECTION_REQUEST = 'ADD_BEST_COLLECTION_REQUEST'
function addBestCollectionRequest() {
  return { type: ADD_BEST_COLLECTION_REQUEST }
}

export const ADD_BEST_COLLECTION_SUCCESS = 'ADD_BEST_COLLECTION_SUCCESS'
function addBestCollectionSuccess(addBestCollection) {
  return { type: ADD_BEST_COLLECTION_SUCCESS, addBestCollection }
}

export const ADD_BEST_COLLECTION_ERROR = 'ADD_BEST_COLLECTION_ERROR'
function addBestCollectionError(error) {
  return { type: ADD_BEST_COLLECTION_ERROR, error }
}


export function addBestCollection(data) {
  return (dispatch) => {
    dispatch(addBestCollectionRequest())
    return api.addBestCollection(data).then(
      (res) => {
        dispatch(addBestCollectionSuccess(res))
        return res
      },
      (error) => {
        dispatch(addBestCollectionError(error))
        return error
      }
    )
  }
}



//remove Best Collectio
export const REMOVE_BEST_COLLECTION_REQUEST = 'REMOVE_BEST_COLLECTION_REQUEST'
function removeBestCollectionRequest() {
  return { type: REMOVE_BEST_COLLECTION_REQUEST }
}

export const REMOVE_BEST_COLLECTION_SUCCESS = 'REMOVE_BEST_COLLECTION_SUCCESS'
function removeBestCollectionSuccess(removeFeature) {
  return { type: REMOVE_BEST_COLLECTION_SUCCESS, removeFeature }
}

export const REMOVE_BEST_COLLECTION_ERROR = 'REMOVE_BEST_COLLECTION_ERROR'
function removeBestCollectionError(error) {
  return { type: REMOVE_BEST_COLLECTION_ERROR, error }
}


export function removeBestCollection(data) {
  return (dispatch) => {
    dispatch(removeBestCollectionRequest())
    return api.removeBestCollection(data).then(
      (res) => {
        dispatch(removeBestCollectionSuccess(res))
        return res
      },
      (error) => {
        dispatch(removeBestCollectionError(error))
        return error
      }
    )
  }

}

//Get Best Collection
export const GET_BEST_COLLECTION_REQUEST = 'GET_BEST_COLLECTION_REQUEST'
function getBestCollectionRequest() {
  return { type: GET_BEST_COLLECTION_REQUEST }
}

export const GET_BEST_COLLECTION_SUCCESS = 'GET_BEST_COLLECTION_SUCCESS'
export function getBestCollectionSuccess(bestCollection) {
  return { type: GET_BEST_COLLECTION_SUCCESS, bestCollection }
}

export const GET_BEST_COLLECTION_ERROR = 'GET_BEST_COLLECTION_ERROR'
function getBestCollectionError(error) {
  return { type: GET_BEST_COLLECTION_ERROR, error }
}

export function getBestCollection() {

  return (dispatch) => {
    dispatch(getBestCollectionRequest())
    return api.getBestCollection().then(
      (res) => {
        dispatch(getBestCollectionSuccess(res))
        return res
      },
      (error) => {
        dispatch(getBestCollectionError(error))
        return error
      }
    )
  }

}

export const COMMENTED_ITEMS_REQUEST = 'COMMENTED_ITEMS_REQUEST'
function commentedItemsRequest() {
  return { type: COMMENTED_ITEMS_REQUEST }
}

export const COMMENTED_ITEMS_SUCCESS = 'COMMENTED_ITEMS_SUCCESS'
function commentedItemsSuccess(commentedItems) {
  return { type: COMMENTED_ITEMS_SUCCESS, commentedItems }
}

export const COMMENTED_ITEMS_ERROR = 'COMMENTED_ITEMS_ERROR'
function commentedItemsError(error) {
  return { type: COMMENTED_ITEMS_ERROR, error }
}


export function commentedItemsList() {
  return (dispatch) => {
    dispatch(commentedItemsRequest())
    return api.getCommentedItems().then(
      (res) => {
        dispatch(commentedItemsSuccess(res))
        return res
      },
      (error) => {
        dispatch(commentedItemsError(error))
      })
  }
}